<template>
  <div class="assetCardSocialStats"
    v-loading="loading"
  >
    <div class="assetCardSocialStats-main">
      <div class="assetCardSocialStats-main-header">
        <div class="assetCardSocialStats-main-header-title">Social Actions</div>
      </div>

      <div class="assetCardSocialStats-main-body">
        <div class="assetCardSocialStats-main-body-graph">
          <stat-popover-graph :data="chartData"
            :hero-stat="heroStat"
          ></stat-popover-graph>
        </div>

        <div class="assetCardSocialStats-main-body-table">
          <stat-popover-table :data="tableData"
            :columns="columns"
          ></stat-popover-table>
        </div>
      </div>
    </div>

    <div class="assetCardSocialStats-footer"
      v-if="footerData"
    >
      <div class="assetCardSocialStats-footer-container"
        v-for="(data, index) in footerData"
        :key="index"
      >
          <span class="assetCardSocialStats-footer-container-label">{{ data.label }}:</span>

          <span class="assetCardSocialStats-footer-container-value">{{ data | nebFormat }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import StatPopoverGraph from './StatPopoverGraph'
import StatPopoverTable from './StatPopoverTable'
import ApiClient from '@/components/api-client'

export default {
  name: 'AssetCardSocialStats',

  components: {
    StatPopoverGraph,
    StatPopoverTable
  },

  props: {
    assetId: {
      type: String,
      required: true
    },
    metricDateStart: {
      type: String,
      required: true
    },
    metricDateEnd: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    chartData: [],
    tableData: [],
    footerData: [],
    columns: [],
    heroStat: { value: '' },
    extraData: null,
    statsLoaded: false,
    loading: true
  }),

  computed: {
    popoverStyle () {
      return this.loading ? {width: '355px'} : {}
    }
  },

  methods: {
    getData () {
      const metricDateRange = [
        this.metricDateStart,
        this.metricDateEnd
      ]

      return ApiClient.getSocialStatsWithBrand(this.assetId, this.brandId, metricDateRange)
    },
    loadData () {
      if (this.statsLoaded) { return }

      this.loading = true

      return this.getData()
        .then(({ data }) => {
          this.chartData = data.chartData
          this.tableData = data.tableData
          this.footerData = data.footerData
          this.columns = data.columns
          this.heroStat = data.heroStat
          this.extraData = data.extraData
        })
        .catch(() => { return })
        .finally(() => {
          this.loading = false
          this.statsLoaded = true
        })
    }
  },

  watch: {
    visible (newValue) {
      if (newValue) {
        this.loadData()
      }
    },
    metricDateStart () { this.statsLoaded = false },
    metricDateEnd () { this.statsLoaded = false },
    assetId () { this.statsLoaded = false }
  }
}
</script>

<style lang="scss" scoped>
.assetCardSocialStats {
  color: #5c5e62;
  &-main {
    padding: 22px 25px 20px 25px;
    &-header {
      display: flex;
      justify-content: space-between;

      &-title {
        height: 32px;
        text-transform: uppercase;
        font-size: 14px;
        letter-spacing: 0.3px;
      }

    }

    &-body {
      margin: 0 5px;
      display: flex;

      &-graph {
        display: flex;
        align-items: center;
      }

      &-table {
        margin-left: 30px;
        display: flex;
        align-items: center;
      }
    }
  }

  &-footer {
    border-top: solid 1px #cecece;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    &-container {
      height: 25px;

      &-label {
        font-size: 10px;
        text-transform: uppercase;
      }

      &-value {
        font-weight: bold;
        font-style: 11px;
        margin-left: 5px;
      }
    }
  }

}
</style>
